import React, { useState, useEffect } from 'react'
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import '../../../../styles/table.admin.css';
import './cashbackBalanceStatistics.css';
import Menu from '../../elements/Menu/menu';
import PageMode from '../../elements/PageMode/pageMode';
import Pagination from '../../elements/Pagination/pagination';

const MODES = [ 'ALL', 'WITH_MIN_WITHDRAW', 'WITHOUT_MIN_WITHDRAW', 'WITH_VOLUME_&_0_CASHBACK' ];

export default function CashbackBalanceStatistics() {
    const [ state, setState ] = useState({
        mode: 'ALL',

        page: null,
        pages: null,

        minWithdraw: null,
        totalBalances: null,
        totalBalancesWithoutMinWithdraw: null,
        totalBalancesWithMinWithdraw: null,
        totalUsersWithBalances: null,
        totalUsersWithoutMinWithdrawBalances: null,
        totalUsersWithMinWithdrawBalances: null,
        usersWithBalance: null,
        usersWithMinWithdrawBalances: null,
        usersWithoutMinWithdrawBalances: null,
    
        totalUsersWithVolumeAnd0Cashback: null,
        usersWithVolumeAnd0Cashback: null
    });

    useEffect(() => {
        const main = async () => {
            try {
                const balanceStatistics = await getBalanceStatistics(1);
                setState(state => { return { ...state, ...balanceStatistics } });

            } catch (error) {
                console.log(error);
                alert(error.message);
            }
        };
        main();
    }, []);

    const getBalanceStatistics = async (page = 1) => {
        const response = await axios.get(config.backendUrl + '/cashback/balances-statistics?page=' + page, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .catch(error => {
            console.log(error);
            alert(error.message);
        });

        console.log(response.data);

        return response.data;
    };

    const modeOnChangeHandler = (event) =>  setState({ ...state, mode: event.target.value });

    const pageOnClickHandler = (page) => async () => {
        const balanceStatistics = await getBalanceStatistics(page);
        setState(state => { return { ...state, ...balanceStatistics } });
    };

    const renderBasicInfo = () => {
        return(
            <div className="balancesStatistics__basicInfo_wrapper">
                <div>
                    <span className="balancesStatistics__basicInfo_label">Total balances:</span>
                    { state.totalBalances || '[No data]' } USDT
                </div>
                <div>
                    <span className="balancesStatistics__basicInfo_label">Balances with min withdraw:</span>
                    { state.totalBalancesWithMinWithdraw || '[No data]' } USDT
                </div>
                <div>
                    <span className="balancesStatistics__basicInfo_label">Balances without min withdraw:</span>
                    { state.totalBalancesWithoutMinWithdraw || '[No data]' } USDT
                </div>
                {/* --------------------- */}
                <div className="balancesStatistics__basicInfo_marginTop10">
                    <span className="balancesStatistics__basicInfo_label">Total users with balances:</span>
                    { state.totalUsersWithBalances || '[No data]' }
                </div>
                <div>
                    <span className="balancesStatistics__basicInfo_label">Users with min withdraw balance:</span>
                    { state.totalUsersWithMinWithdrawBalances || '[No data]' }
                </div>
                <div>
                    <span className="balancesStatistics__basicInfo_label">Users without min withdraw balance:</span>
                    { state.totalUsersWithoutMinWithdrawBalances || '[No data]' }
                </div>
                <div>
                    <span className="balancesStatistics__basicInfo_label">Users with volumes and 0 cashback balance:</span>
                    { state.totalUsersWithVolumeAnd0Cashback || '[No data]' }
                </div>
                {/* --------------------- */}
                <div className="balancesStatistics__basicInfo_marginTop10">
                    <span className="balancesStatistics__basicInfo_label">Min withdraw:</span>
                    { state.minWithdraw || '[No data]' } USDT
                </div>
            </div>
        );
    };

    const renderTable = () => {
        switch (state.mode) {
            case 'ALL': return renderBalancesTable(state.usersWithBalance);
            case 'WITH_MIN_WITHDRAW': return renderBalancesTable(state.usersWithMinWithdrawBalances);
            case 'WITHOUT_MIN_WITHDRAW': return renderBalancesTable(state.usersWithoutMinWithdrawBalances);
            case 'WITH_VOLUME_&_0_CASHBACK': return renderVolumesTable(state.usersWithVolumeAnd0Cashback);
        
            default:
                console.log('Invalid mode: ' + state.mode);
                return;
        }
    }

    const renderBalancesTable = (usersArray) => {
        if (!usersArray || !usersArray.length) { return; }

        return(
            <div className="balancesStatistics__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Cashback token</th>
                            <th>Balance</th>
                            { state.mode === 'ALL' ? <th>Label</th> : null }
                        </tr>
                    </thead>
                    <tbody>
                        { usersArray.map((userData, index) => {
                            return(
                                <tr key={ index }>
                                    <td>{ userData.cashbackToken }</td>
                                    <td>{ userData.balance }</td>
                                    { state.mode === 'ALL' ? <td>{ userData.cashbackLabel || '–' }</td> : null }
                                </tr>
                            );
                        }) }
                    </tbody>
                </table>
                {
                    state.mode === 'ALL' ?
                        <Pagination activePage={ state.page } pages={ state.pages } onClickHandler={ pageOnClickHandler }/>
                        : null
                }
            </div>
        );
    };

    const renderVolumesTable = (usersArray) => {
        if (!usersArray || !usersArray.length) { return; }

        return(
            <div className="balancesStatistics__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Cashback token</th>
                            <th>Weekly volume</th>
                            <th>Overall volume</th>
                        </tr>
                    </thead>
                    <tbody>
                        { usersArray.map((userData, index) => {
                            return(
                                <tr key={ index }>
                                    <td>{ userData.cashbackToken }</td>
                                    <td>{ userData.weeklyVolume }</td>
                                    <td>{ userData.overallVolume }</td>
                                </tr>
                            );
                        }) }
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <>
            <CheckAuth />
            <Menu />
            <>
                { renderBasicInfo() }
                <div className='pageMode__mobile'>
                    <PageMode modesArray={ MODES } checkedMode={ state.mode } onChangeHandler={ modeOnChangeHandler } />
                </div>
                { renderTable() }
            </>
        </>
    );
};
